import { render, staticRenderFns } from "./CustomerAddDialog.vue?vue&type=template&id=097bed2d&"
import script from "./CustomerAddDialog.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports